<div class="main-font widget-container">
  <p class="title-widget mb-0">Monitoraggio - Delta incrementale</p>
  <ng-container *ngIf="monitorignData && !isLoading">
    <nz-tabset *ngIf="!isEdit">
      <nz-tab [nzTitle]="titleTemplateTeam" (nzClick)="onTabChange('Team')">
        <app-monitoring-incremental-delta-card
          [userMonitoring]="teamMonitoringVelocities">
        </app-monitoring-incremental-delta-card>
      </nz-tab>
      <ng-template #titleTemplateTeam>
        <div class="title-container">
          <p
            class="mb-0 title-tabset"
            [ngClass]="{ 'selected-title': selectedTab == 'Team' }">
            Team
          </p>
          <p
            class="mb-0 velocity-text"
            [ngClass]="{ 'selected-velocity': selectedTab == 'Team' }">
            {{ velocityTeam }}
          </p>
        </div>
      </ng-template>
      <nz-tab
        [nzTitle]="titleTemplateCliente"
        (nzClick)="onTabChange('Cliente')">
        <app-monitoring-incremental-delta-card
          [userMonitoring]="clientMonitoringVelocities">
        </app-monitoring-incremental-delta-card>
      </nz-tab>
      <ng-template #titleTemplateCliente>
        <div class="title-container">
          <p
            class="mb-0 title-tabset"
            [ngClass]="{ 'selected-title': selectedTab == 'Cliente' }">
            Cliente
          </p>
          <p
            class="mb-0 velocity-text"
            [ngClass]="{ 'selected-velocity': selectedTab == 'Cliente' }">
            {{ velocityClient }}
          </p>
        </div>
      </ng-template>
    </nz-tabset>

    <!-- INIZIO CAMILLO -->
    <div class="summary-widget_resume">
      <nz-collapse
        [nzExpandIconPosition]="'right'"
        [nzAccordion]="true"
        class="mt-2">
        <nz-collapse-panel [nzHeader]="HeaderTemplate" [nzActive]="true">
          <!-- INIZIO CONTENUTO -->
          <div
            *ngIf="!isEditSummary"
            class="camillo-content custom-editor-output-css"
            [innerHTML]="summary"></div>

          <div class="camillo-editor">
            <angular-editor
              [(ngModel)]="summary"
              *ngIf="isEditSummary"
              [config]="editorConfig"></angular-editor>
          </div>
          <!-- FINE CONTENUTO -->

          <ng-template #HeaderTemplate>
            <nz-row
              class="d-flex align-items-center w-100"
              nzJustify="space-between">
              <!-- Camillo profile -->
              <nz-col>
                <div class="camillo">
                  <img
                    class="camillo-img"
                    src="assets/images/camillo/camillo-sbi.png"
                    alt="" />
                  <div class="camillo-say">Camillo ti dice...</div>
                </div>
              </nz-col>
              <!-- End Camillo profile -->

              <!-- Note, Suggestion and Edit -->
              <nz-col>
                <button
                  *ngIf="userRole == 'admin' && !isEditSummary"
                  class="camillo-edit"
                  (click)="$event.stopPropagation(); editSummary($event)">
                  <img src="assets/images/Sbi/edit.svg" alt="" />
                  modifica
                </button>

                <button
                  *ngIf="isEditSummary"
                  class="camillo-submit_btn generic-btn-disable"
                  (click)="$event.stopPropagation(); saveSummary($event)">
                  Salva
                </button>
              </nz-col>
              <!-- End Note, Suggestion and Edit -->
            </nz-row>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <!-- END CAMILLO -->
  </ng-container>

  <ng-container *ngIf="isLoading">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
  </ng-container>
</div>
